//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
import { ref, onMounted } from '@vue/composition-api'
import { mdiMagnify } from '@mdi/js'
import { useUtils } from '@core/libs/i18n'
import { useRouter, formatCurrency } from '@core/utils'
import themeConfig from '@themeConfig'
import useCryptoJs from '@core/utils/useCryptoJs'

import useLogData from '@core/utils/useLogData'
import useVideoData from '@core/utils/useVideoData'

import AppBarUserAvatar from '@core/layouts/components/app-bar/AppBarUserAvatar.vue'
import FacilityList from './facility-list/FacilityList.vue'

import useFacilities from './useFacilities'

export default {
  components: {
    FacilityList,
    AppBarUserAvatar,
  },
  setup() {
    const { t } = useUtils()
    const { router } = useRouter()
    const { userData } = useCryptoJs()
    const { logData, updateLogData, clearLogData } = useLogData()
    const { videoData, updateVideoData, clearVideoData } = useVideoData()
    const {
      search,
      itemSelected,
      facilities,
      facilitiesLoaded,
      latitudeData,
      longitudeData,

      fetchFacilities,
    } = useFacilities()

    const privateLanding = ref(false)

    const onSelectFacility = async facility => {
      itemSelected.value = facility
      videoData.value.facility = facility
      await updateVideoData(videoData.value)

      if (itemSelected.value) {
        router.push({
          name: 'views-video',
          params: {
            facility: itemSelected.value.id,
            field: 'all',
            date: 'all',
            time: 'all',
          },
        })
      }
    }

    const onLogin = async () => {
      logData.value.joinGame = 'NO'
      logData.value.matchCode = null
      logData.value.redirect = 'facilities'
      logData.value.field = 'all'
      logData.value.date = 'all'
      logData.value.time = 'all'
      await updateLogData(logData.value)

      router.push({ name: 'auth-login-phone-email' })
    }

    const onLogout = async () => {
      await localStorage.removeItem('userData')
      privateLanding.value = false
    }

    onMounted(async () => {
      await localStorage.removeItem('matchCode')
      privateLanding.value = !!userData.value

      if (!privateLanding.value) {
        await clearLogData()
        await clearVideoData()
      }

      // await fetch('https://api.ipify.org/?format=json')
      //   .then(ipResponse => ipResponse.json())
      //   .then(async ipData => {

      //     await fetch(`https://ip-api.com/json/${ipData.ip}`)
      //       .then(locationResponse => locationResponse.json())
      //       .then(async locationData => {
      //         latitudeData.value = locationData.lat
      //         longitudeData.value = locationData.lon

      //         await fetchFacilities()
      //       })
      //   })

      await fetchFacilities()

      // This will open permission popup
      navigator.geolocation.getCurrentPosition(async position => {
        const { latitude } = position.coords
        const { longitude } = position.coords

        // Do something with the position
        latitudeData.value = latitude
        longitudeData.value = longitude
        await fetchFacilities()
      }, err => {
        console.error(err)
      })
    })

    return {
      // data
      privateLanding,
      userData,
      search,
      itemSelected,
      facilities,
      facilitiesLoaded,

      // methods
      formatCurrency,
      onSelectFacility,
      onLogin,
      onLogout,

      // themeConfig
      appLogoTitle: themeConfig.app.logoTitle,

      t,

      icons: {
        mdiMagnify,
      },
    }
  },
}
